import { mediaQueries } from '@centivo/react-components'
import { css } from 'styled-components'

export const responsiveStyles = css`
  @media ${mediaQueries.desktop} {
    max-width: 1432px;
  }

  @media ${mediaQueries.ipadPro}, ${mediaQueries.tablet} {
    max-width: 948px;
  }

  @media ${mediaQueries.mobile} {
    padding-right: 1rem;
    padding-left: 1rem;
    max-width: 720px;
  }

  @media ${mediaQueries.iphone} {
    max-width: 540px;
  }
`
